import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-h4 text-weight-medium" }, "Messages", -1)
const _hoisted_3 = { class: "q-mt-sm" }
const _hoisted_4 = {
  key: 0,
  class: "q-my-sm text-caption text-grey-7 text-center"
}
const _hoisted_5 = {
  key: 0,
  class: "q-my-sm text-caption text-grey-7 text-center"
}
const _hoisted_6 = { class: "q-my-sm text-caption text-grey-7 text-center" }

import { ref } from 'vue'
import MessageInboxItem from '../components/MessageInboxItem.vue'
import BannerOffline from '../components/BannerOffline.vue'
import FormMessage from '../components/FormMessage.vue'
import { storeToRefs } from 'pinia'
import { useMessages } from '../store/useMessages'
import { useQuasar } from 'quasar'
import { useI18n } from 'vue-i18n'
import { useNetwork } from '../composables/useNetwork'


export default /*#__PURE__*/_defineComponent({
  __name: 'PageMessaging',
  setup(__props, { expose: __expose }) {

const { getStatus } = useNetwork()
const { t } = useI18n({ useScope: 'global' })
const messageLabel = (label: string) => t(`messaging.${label}`)
const formLabel = (label: string) => t(`form.${label}`)

const modalNewMessage = ref(false)
const tab = ref('inbox')

const {
  getMessagesInbox: inboxMessages,
  getMessagesOutbox: outboxMessages,
  unread,
} = storeToRefs(useMessages())
const { markRead, send } = useMessages()

//for ripple
const $q = useQuasar()
__expose({ $q })

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BannerOffline, { "data-test": "pageInventory" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(messageLabel('offline')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_q_page, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_q_btn, {
              color: "primary",
              rounded: "",
              "no-caps": "",
              label: formLabel('newMessage'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(getStatus) ? (modalNewMessage.value = true) : undefined))
            }, null, 8, ["label"])
          ])
        ]),
        _createVNode(_component_q_tabs, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
          class: "text-grey",
          "active-color": "secondary",
          "indicator-color": "secondary",
          align: "left",
          "inline-label": "",
          "narrow-indicator": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tab, {
              name: "inbox",
              label: messageLabel('inbox')
            }, {
              default: _withCtx(() => [
                (_unref(unread))
                  ? (_openBlock(), _createBlock(_component_q_badge, {
                      key: 0,
                      color: "secondary",
                      floating: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(unread)), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_q_tab, {
              name: "sent",
              label: messageLabel('sent')
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_q_separator),
        _createVNode(_component_q_tab_panels, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tab).value = $event)),
          animated: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tab_panel, {
              name: "inbox",
              class: "no-padding"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, { separator: "" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(inboxMessages), (message) => {
                      return (_openBlock(), _createBlock(MessageInboxItem, _mergeProps({
                        key: message.id,
                        sent: false,
                        onClick: ($event: any) => (
                _unref(markRead)(message.id), _ctx.$router.push({ name: 'message', params: { id: message.id } })
              )
                      }, message), null, 16, ["onClick"]))
                    }), 128)),
                    (1 > _unref(inboxMessages).length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(messageLabel('noMessagesInbox')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_separator)
              ]),
              _: 1
            }),
            _createVNode(_component_q_tab_panel, {
              name: "sent",
              class: "no-padding"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, { separator: "" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(outboxMessages), (message) => {
                      return (_openBlock(), _createBlock(MessageInboxItem, _mergeProps({
                        key: message.id,
                        sent: "",
                        onClick: ($event: any) => (_ctx.$router.push({ name: 'message', params: { id: message.id } }))
                      }, message), null, 16, ["onClick"]))
                    }), 128)),
                    (1 > _unref(outboxMessages).length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(messageLabel('noMessagesOutbox')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_separator),
                _createElementVNode("p", _hoisted_6, _toDisplayString(messageLabel('sentMessagesRemoved')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_q_dialog, {
      modelValue: modalNewMessage.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modalNewMessage).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"width":"480px","max-width":"80vw"},
          class: "q-pa-md"
        }, {
          default: _withCtx(() => [
            _createVNode(FormMessage, { onSend: _unref(send) }, null, 8, ["onSend"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})